import { useUser } from '@clerk/clerk-react';

export function clerkSessionState(isLoaded: boolean, isSignedIn: boolean | undefined) {
  return {
    isLoaded,
    signedIn: Boolean(isLoaded && isSignedIn),
    signedOut: Boolean(isLoaded && !isSignedIn),
  };
}

export function useClerkSession() {
  const { isLoaded, isSignedIn, user } = useUser();
  return {
    ...clerkSessionState(isLoaded, isSignedIn),
    user,
  };
}
